import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { getTeamsV2 } from '@/common/services/TeamsService'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { SERVER_DATA_LABELS, SERVER_DATA_SCOPE, type GroupOptionsBase } from '@/common/types/cacheConstants'

function groupOptions(config: GroupOptionsBase = {}) {
  const defaultConfig = {
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.TEAMS,
    }),
    staleTime: Infinity,
    queryFn: getTeamsV2,
  }
  return queryOptions(merge(defaultConfig, config))
}

async function fetch(options: GroupOptionsBase = {}) {
  const { staleTime } = options
  const [result] = await Promise.all([
    queryClient.fetchQuery(groupOptions(options)),
    localizationServerData.fetch({
      prefixes: SERVER_DATA_LABELS.TEAMS,
      staleTime,
    }),
  ])
  return result
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.TEAMS,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
